import { Button, Popup, SafeArea, Toast, ActionSheet } from "antd-mobile";
import { PropsWithChildren } from "react";
import styles from "./index.module.scss";
import { useLogic } from "./logic";
import type { Action, ActionSheetShowHandler } from 'antd-mobile/es/components/action-sheet';
const actions: Action[] = [{
  text: '复制',
  key: 'copy'
}, {
  text: '修改',
  key: 'edit'
}, {
  text: '保存',
  key: 'save'
}];
export function ScanPopup(props: PropsWithChildren) {
  const logic = useLogic();
  const onQrCodeFileChange = (e: any) => {
    // @ts-ignore
    if (e.target.files.length === 0) {
      return;
    }
    // @ts-ignore
    const imageFile = e.target.files[0];
    logic.scanImage(imageFile);
  };
  return <div data-sentry-component="ScanPopup" data-sentry-source-file="index.tsx">
      <div onClick={logic.handleScan}>{props.children}</div>
      {/* <ActionSheet
        visible={logic.visible}
        actions={actions}
        onClose={() => logic.cancelScan()}
       /> */}

      <Popup className={styles.sannerPopup} visible={logic.visible} onMaskClick={logic.cancelScan} data-sentry-element="Popup" data-sentry-source-file="index.tsx">
        <div className={styles.page}>
          {/* <ScanSquare /> */}
          <div className={styles.scanArea}>
            {/* <div id="reader" style={{width: '300px',height: '300px',position:'relative'}}></div> */}
            <video id="reader" style={{
            width: '300px !important',
            height: '300px !important',
            position: 'relative'
          }}></video>
          </div>
          <div className={styles.btns}>
            <Button className={styles.start} onClick={logic.startScan} data-sentry-element="Button" data-sentry-source-file="index.tsx">
              {logic.scanning ? "停止扫描" : "开始扫描"}
            </Button>
            <Button className={styles.image} data-sentry-element="Button" data-sentry-source-file="index.tsx">
              扫描图片
              {logic.visible ? <input id="qr-input-file" accept="image/*" type="file" onChange={onQrCodeFileChange} /> : null}
            </Button>
          </div>
        </div>
        <SafeArea position={"bottom"} data-sentry-element="SafeArea" data-sentry-source-file="index.tsx" />
      </Popup>
    </div>;
}